const demoUsers = [{
  hotelId: 300000742,
  name: '0000'
}, {
  hotelId: 1135292,
  name: '0000'
}];

export const isDemoUser = (hotelId, name) => {
  let ret = false;
  for (let i = 0, length = demoUsers.length; i < length; i++) {
    if (demoUsers[i].hotelId === hotelId && demoUsers[i].name === name) {
      ret = true;
      break;
    }
  }
  return ret;
};

const reportUser = {
  'pre.e.fanxiaojian.cn': [300002449, 300002452, 300002450, 300002451, 20051387, 300002459,
    300002456, 300002457, 300002458, 20051398, 300002480, 300002483, 300002482],
  'e.passiontec.cn': [1213729, 1213684, 1213754, 1213745, 160176, 1215947, 1215919, 1215927,
    1215939, 163385, 1030354, 1065564, 1034338, 1217569, 1058533, 1218916, 1065946, 1222510, 1227329, 1227321, 173278, 1214828, 161808]
};

export const isReportDemoUser = (hotelId) => {
  const env = reportUser[location.host];
  if (location.host === 'alitest.e.fanxiaojian.cn') {
    return true;
  }
  if (!env) {
    return false;
  }
  if (env.indexOf(window.parseInt(hotelId)) !== -1) {
    return true;
  }
};



// WEBPACK FOOTER //
// ./src/utils/demoUtils.js